<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="items"
      :items-per-page="5"
      :search="search"
      class="elevation-1 mb-10"
      @click:row="onRowClick"
      style="cursor: pointer;"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <b>{{ $t(title) }}</b>
          </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <div class="search-bar">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('table.search')"
              single-line
              hide-details
            ></v-text-field>
          </div>
          <v-spacer></v-spacer>

          <div class="text-center mr-5">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <a
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  style="text-decoration: underline;"
                >{{ $t('table.export') }}</a>
              </template>
              <v-list>
                <!-- Need to include click action to have hover animation -->
                <JsonExcel :data="items" type="csv" :name="title +'.csv'">
                  <v-list-item @click="onExportCsv()">
                    <v-list-item-title>CSV</v-list-item-title>
                  </v-list-item>
                </JsonExcel>

                <v-list-item @click="onExportPdf()">
                  <!-- Need to include click action to have hover animation -->
                  <v-list-item-title>PDF</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <v-btn dark class="mb-2 primary-color" tile @click="addItem()">
            <v-icon size="20" class="mr-1">mdi-plus</v-icon>
            {{ $t('table.add') }} awarding org.
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="20"
              class="mr-1"
              v-bind="attrs"
              v-on="on"
              @click="editItem(item)"
            >mdi-pencil</v-icon>
          </template>
          <span>{{ $t('table.edit') }}</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              size="20"
              class="ml-1"
              v-bind="attrs"
              v-on="on"
              @click.stop="deleteItem(item)"
            >mdi-delete</v-icon>
          </template>
          <span>{{ $t('table.delete') }}</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  components: {
    JsonExcel,
  },
  props: {
    headers: Array,
    items: Array,
    title: String,
    btnText: String,
    routeTo: String,
    apiRoute: String,
    modalText: String,
  },
  data: () => ({
    show: false,
    search: "",
    deleteDialog: false,
    pdfData: null,
    pdfHeader: [
      { text: "Usernmae", style: "tableHeader" },
      { text: "Email", style: "tableHeader" },
      { text: "Role", style: "tableHeader" },
    ],
  }),
  methods: {
    onRowClick(item) {
      this.$router.push({ path: "ao/summary", query: { id: item._id } });
    },
    addItem() {
      this.$router.push({ name: "AoDetails" });
    },
    editItem(item) {
      this.$router.push({ path: "ao/details", query: { id: item._id } });
    },
    deleteItem(item) {
      const confirmDelete = window.confirm(
        `Are you sure to delete ${item.name}?`
      );
      if (confirmDelete) {
        this.onDeleteOption(item._id);
      }
    },
    onDeleteOption: function (id) {
      fetch(`${process.env.VUE_APP_ROOT_API}/${this.apiRoute}/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.$store.state.jwt}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          const feedbackData = { title: this.apiRoute, message: data.message };
          this.$emit("optionAdded", feedbackData);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    onExportCsv: function () {
      console.log("Exporting csv...");
    },
    onExportPdf: function () {
      this.pdfData = this.items.map((item) => [
        item.username,
        item.email,
        item.role,
      ]);

      this.pdfData.unshift(this.pdfHeader);

      var doc = {
        content: [
          { text: `${this.title} List`, style: "header" },
          {
            style: "tableExample",
            table: {
              widths: ["*", "*", "*"],
              headerRows: 1,
              body: this.pdfData,
            },
          },
        ],
        styles: {
          header: {
            fontSize: 18,
            bold: true,
            margin: [0, 0, 0, 10],
          },
          subheader: {
            fontSize: 16,
            bold: true,
            margin: [0, 10, 0, 5],
          },
          tableExample: {
            margin: [0, 5, 0, 15],
          },
          tableHeader: {
            bold: true,
            fontSize: 13,
            color: "black",
          },
        },
      };
      pdfMake.createPdf(doc).open();
    },
  },
};
</script>

<style scoped>
.search-bar {
  width: 200px;
}
</style>